import React from 'react';
import { useTranslation } from 'react-i18next';

import { MANTY_AUTH } from 'business/constants';
import { findSSOAuthAuth, includesSSO } from 'helpers/helpers';
import { useSelector } from 'store/hooks';

import { MODULES_TRANSLATION_PATH } from './helpers/constants';
import GenericSwitchBar from './ui/GenericSwitchBar';

type Props = {
    changeAuthMethod: (auth: string) => void;
    authMethods: string[];
};

const AuthSection = ({ changeAuthMethod, authMethods }: Props): JSX.Element => {
    const { t } = useTranslation();

    const clientAuthMethods = useSelector(
        (state) => state.vision.client.authMethods,
    );
    const isClientUsingSSO = includesSSO(clientAuthMethods);

    if (!isClientUsingSSO) return <></>;

    const ssoMethod = findSSOAuthAuth(clientAuthMethods);
    const isCreatedUserUsingSSO = includesSSO(authMethods);

    const handleAuthMethodChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => changeAuthMethod(event.target.checked ? ssoMethod : MANTY_AUTH);

    return (
        <GenericSwitchBar
            title={t(`${MODULES_TRANSLATION_PATH}.titles.sso`)}
            checked={isCreatedUserUsingSSO}
            onChange={handleAuthMethodChange}
        />
    );
};

export default AuthSection;
